import type {
  BillingChangeRequestType,
  CaseStatus,
  CaseResolution,
} from "~/graphql/supergraphTypes";

export type { CaseStatus, CaseResolution };

export type TextFilter = {
  filterType: "text";
  type: string;
  filter: string;
};

export enum BillingCaseType {
  ClientInformation = "CLIENT_INFORMATION",
  FirstCapitalCallDate = "FIRST_CAPITAL_CALL_DATE",
}

export type BillingCaseRowItem = {
  changeRequestId: string;
  familyId: string | null;
  clientId: number;
  billingCaseId: number;
  type: BillingCaseType;
  requestType: BillingChangeRequestType | null;
  clientName: string;
  creationDate: string;
  status: CaseStatus;
  resolution: CaseResolution | null;
  assignee: string | null;
  secondaryAssignee: string | null;
  assigneeId: number | null;
  resolvedByName: string | null;
};
